
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Icons } from './components';

@Component({
  components: {
    Icons,
  },
})
export default class Progress extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly result!: Array<any>;

  get progressList(): Array<any> {
    return this.$store.state.nokoProgressResult || [];
  }

  showProgress(value: string): string {
    const result = this.progressList.find(({ id }) => id === value);
    return result ? `${result.name}` : 'Не определен';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/progress/components/result/components/progress/Progress.vue